import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { EntityViewLayout } from "../entityLayout/entityViewLayout";
import {
  deleteCoach,
  getAllCoaches,
  updateCoach,
} from "../../store/coaches/coachesAction";

export const ShowCoachesTable = () => {
  const coach = useSelector((state) => state.coach);
  const { isLodaing } = useSelector((state) => state.errors);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const isViewer = user.role_id === 5 || user.roleId === 5;

  const tableProps = {
    name: "Coaches",
    routePath: "/coaches",
    addNewText: "Add new coach",
    sideMenuItem: "coaches",
    isBreadcrumbs: true,
    isAddNew: isViewer ? false : true,
    isSearch: true,
    columns: [
      {
        Header: "S.No",
        id: "row",
        type: "index",
        accessor: "id",
        maxWidth: 75,
        filterable: false,
      },
      {
        Header: "Coach",
        type: "image",
        id: "row_img",
        maxWidth: 150,
        accessor: "image",
        paddingTop: "35px",
        filterable: false,
      },
      {
        Header: "Coach Name",
        accessor: "name",
        paddingTop: "35px",
      },
      {
        Header: "Rating",
        type: "rating",
        id: "row_star",
        accessor: "rating_avg",
        maxWidth: 150,
        filterable: false,
      },
      isViewer
        ? {
            Header: "Action",
            type: "actions",
            isViewButton: true,
            isEditButton: false,
            isStatusButton: false,
            isDeleteButton: false,
          }
        : {
            Header: "Action",
            type: "actions",
            isViewButton: true,
            isEditButton: true,
            isStatusButton: true,
            isDeleteButton: true,
          },
    ],
  };

  const searchFields = ["name", "email"];
  let history = useHistory();

  const updateItem = (is_active, id, history) => {
    dispatch(updateCoach(is_active, id, history));
  };

  const deleteItem = (id) => {
    dispatch(deleteCoach(id));
  };

  useEffect(() => {
    dispatch(getAllCoaches());
  }, []);

  return (
    <EntityViewLayout
      isLoading={isLodaing}
      items={coach.coaches}
      searchFields={searchFields}
      tableProps={tableProps}
      history={history}
      updateItem={updateItem}
      deleteItem={deleteItem}
    />
  );
};
